import React from 'react';
import PropTypes from 'prop-types';
// import { noop } from '../propTypes';
import FormInput from '../FormInput';
import DropDown from '../DropDown';
import { DROPDOWN_VARIANTS } from '../constants';
import './styles.scss';
import { noop } from '../propTypes';

function DropdownFormInput({
    menuData,
    bootstrapIcon,
    title,
    onSelect,
    selected,
}) {
    return (
        <div className="dropdown-input">
            <FormInput title={title} bootstrapIcon={bootstrapIcon}>
                <DropDown
                    label={''}
                    menuData={menuData}
                    onChange={(val) => onSelect(val)}
                    variant={DROPDOWN_VARIANTS.LIST_SIMPLE}
                    selectedOption={selected}
                />
            </FormInput>
        </div>
    );
}

DropdownFormInput.propTypes = {
    menuData: PropTypes.array,
    bootstrapIcon: PropTypes.string,
    title: PropTypes.string,
    selected: PropTypes.string,
    onSelect: PropTypes.func,
};

DropdownFormInput.defaultProps = {
    menuData: [],
    bootstrapIcon: 'icon-flag',
    title: 'Challenges',
    selected: null,
    onSelect: noop,
};

export default DropdownFormInput;
